import { CommonEditLogic } from '@src/slide/content-viewer/service/canvas-renderer/entry/pc-edit/logic/common-edit-logic';
import { InterfaceFactoryOptions } from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-render/elements/factory-options.interface';
import { ComponentFactory } from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-render/elements/component-factory';
import { PropertyEditorShowAction } from '@src/js/constant';
import { IRightSideBarManager } from '@src/slide/application/service/right-side-bar-manager/right-side-bar-manager.interface';
import { IConnectorModel } from '@src/slide/domain/ui-model/element-modeles/Interface/connector-model.interface';
import { IRightSideBarService } from '@src/slide/application/service/right-side-bar-service/core/interface';

export class ConnectorEditLogic extends CommonEditLogic {
    private rightSideBarManager?: IRightSideBarManager;
    private rightSideBarService?: IRightSideBarService;

    public constructor(factoryOptions: InterfaceFactoryOptions<IConnectorModel>, component: ComponentFactory) {
        super(factoryOptions, component);
        this.rightSideBarManager = factoryOptions.rightSideBarManager;

        // 事件绑定
        this.component.inner.onDoubleClick(this.handleInnerDoubleClick);
    }

    private handleInnerDoubleClick = (e) => {
        if (this.factoryOptions.isEditable) {
            e?.stopPropagation();
            this.rightSideBarManager?.setPropertyEditorShowAction(PropertyEditorShowAction.DOUBLE_CLICK_TOOGLE);
            this.rightSideBarService?.hide();
        }
    };
}
